import { FontWeight } from '../../../ui/shared/enums/FontWeight';
import type { DestinationItemArchetype } from '../../../ui/archetypes/DestinationItemArchetype';
import {
  defaultBaseDestination,
  defaultBaseSkin,
  placeholderBaseDestination,
  placeholderBaseSkin,
} from './BaseDestinationDefaults';

export const defaultInternalDestination: Partial<DestinationItemArchetype> = {
  ...defaultBaseDestination,
  ...defaultBaseSkin,
  fontWeight: FontWeight.Normal,
};

export const placeholderInternalDestination: Partial<DestinationItemArchetype> =
  {
    ...placeholderBaseDestination,
    ...placeholderBaseSkin,
    fontWeight: FontWeight.Normal,
  };
